import { AxiosInstance } from 'axios';
import axiosClient from './axiosClientConfig';
import { HttpResponse } from 'interfaces/httpClient';
import { SignDocumentExtracted } from '@/interfaces';

class PdfFormsService {
	constructor(private client: AxiosInstance) {}

	async extractAll(file: File): Promise<HttpResponse<SignDocumentExtracted>> {
		const formData = new FormData();
		formData.append('file', file);
		return this.client.post('/pdf-forms/extract-all', formData, {
			headers: { 'Content-Type': 'multipart/form-data' },
		});
	}
}

export const pdfFormsService = new PdfFormsService(axiosClient);
